class Nav {
  constructor() { this.init(); }

  init() {
    const toggle   = document.querySelector(".js-nav-toggle");
    const nav      = document.querySelector(".js-nav");
    const aboutLi  = document.querySelector(".js-nav-about");
    const aboutBtn = document.querySelector(".js-nav-about-toggle");
    if (!toggle || !nav) return;

    const setOpen = (open) => {
      nav.classList.toggle("is-open", open);
      toggle.classList.toggle("is-active", open);
      toggle.setAttribute("aria-expanded", String(open));
      document.documentElement.classList.toggle("overflow-hidden", open);
      if (!open && aboutLi) aboutLi.classList.remove("is-subopen");
      if (!open && aboutBtn) aboutBtn.setAttribute("aria-expanded", "false");
    };

    toggle.addEventListener("click", () => setOpen(!nav.classList.contains("is-open")));

    if (aboutLi && aboutBtn) {
      aboutBtn.addEventListener("click", (e) => {
        if (window.innerWidth >= 1024) return;
        if (!nav.classList.contains("is-open")) return;
        e.preventDefault();
        const isOpen = aboutLi.classList.toggle("is-active");
        aboutBtn.setAttribute("aria-expanded", String(isOpen));
      });
    }
    document.addEventListener("click", (e) => {
      const within = e.target.closest(".js-nav") || e.target.closest(".js-nav-toggle");
      if (!within && nav.classList.contains("is-open")) setOpen(false);
    });

    const MQ = 1024;
    const onResize = () => {
      if (window.innerWidth >= MQ && nav.classList.contains("is-open")) setOpen(false);
    };
    window.addEventListener("resize", onResize);
  }
}
export default Nav;
